import { browserHistory, Link } from 'react-router';
import { connect } from 'react-redux';
import createReactClass from 'create-react-class';
import React from 'react';
/** import third-party libraries in the section above, keep the ascending order */

import { InlineBlockLoadGroup } from 'packages/widgets-v5/load-group';
import CenterLayout from 'packages/widgets-v5/center-layout';
/** import widgets components in the section above, keep the ascending order */

import { can } from 'services/can';
import { fetchCampaignData, unInitCampaign } from './actions';
import { PermissionsMapping } from 'common/constants/role-intents';
import selector from './selector';
/** import classes and others in the section above, keep the ascending order */

export default ProtectedComponent => {
    const CampaignAccessCheck = createReactClass({
        displayName: 'CampaignAccessCheck',

        statics: {
            refresh(dispatch, nextState) {
                dispatch(fetchCampaignData(nextState.params.campaignId));
            },
        },

        componentDidMount() {
            this.init();
        },

        componentWillUnmount() {
            this.props.dispatch(unInitCampaign());
        },

        init() {
            const { dispatch, location, params, routes } = this.props;
            const nextState = { location, params, routes };

            CampaignAccessCheck.refresh(dispatch, nextState, browserHistory.push);
        },

        render() {
            const { dispatch, location, params, routes, history, workspace, router } = this.props;
            const { loading, accessGranted, ownerName, campaign } = this.props;
            const { campaignId } = this.props.params;

            const topLevelClassNames = 'ef5-campaign-access ef5-text-size_headline';
            const boldedClassNames = 'ef5-campaign-access__bolded';

            if (accessGranted) {
                return (
                    <ProtectedComponent
                        dispatch={dispatch}
                        location={location}
                        params={params}
                        routes={routes}
                        router={router}
                        workspace={workspace}
                        history={history}
                    />
                );
            }

            let message;
            if (loading) {
                message = <div className={topLevelClassNames}>&#32;</div>;
            } else if (!ownerName || !can(PermissionsMapping.IMPERSONATE)) {
                // Show the generic message when the campaign is unavailable to the user or impersonation is not allowed.
                message = (
                    <div className={topLevelClassNames}>
                        You don't have access to campaign #
                        <span className={boldedClassNames}>{campaignId}</span>, or it doesn't exist.
                    </div>
                );
            } else {
                // Only users with impersonation permission should see the impersonation call-to-action.
                message = (
                    <div className={topLevelClassNames}>
                        Your organization doesn't have access to campaign #
                        <span className={boldedClassNames}>{campaignId}</span>. <br />
                        <Link
                            href="#"
                            onClick={e => {
                                e.preventDefault();
                                if (window.handleOpenImpersonate) {
                                    window.handleOpenImpersonate({
                                        organizationFilter: campaign && campaign.organization,
                                        selectedOrganization: campaign && campaign.organization,
                                    });
                                }
                            }}
                            className="ef6-typography--link"
                            title="Click to open Impersonate Dialog"
                        >
                            Try impersonating a user from organization that owns this campaign:
                        </Link>
                        <br />
                        <span className={boldedClassNames}>{this.props.ownerName}</span>
                    </div>
                );
            }

            return (
                <CenterLayout>
                    <InlineBlockLoadGroup size="large" isLoading={this.props.loading}>
                        {message}
                    </InlineBlockLoadGroup>
                </CenterLayout>
            );
        },
    });

    return connect(selector)(CampaignAccessCheck);
};
